module.exports = __webpack_public_path__ + "static/media/turi1.c3241214.jpg";